const getTextVariableName = (customColorName) => {
  const hash = customColorName.split('-').pop();
  return `--text-color-${Date.now()}-${hash}`;
};

export default getTextVariableName;
